import React, {PureComponent} from 'react';
import isEmpty from 'lodash/isEmpty';
import {connect} from 'react-redux';

import Footer from '../components/Footer';
import {Link} from '../components/ReactRouterDomLocalized';
import FormField from '../components/registration/FormField';
import GenderSelect from '../components/common/GenderSelect';

import {dt, getLocale, t} from '../l10n';
import {getFormData} from '../utils/forms';
import {activateUserByCode, registerUser, requestActivationSms, updateActivationEmail} from '../backend-helpers/member';
import {setCurrentUser} from '../reducers/currentUser';
import {getRegions} from '../backend-helpers/misc';

import countries from '../constants/countries';
import {escape} from "../l10n/utils";
import paths from "../paths";
import flags from "../images/flags.png";
import ReactPhoneInput from "react-telephone-input";
import '../sass/react-tel-input.scss';
import {Helmet} from "react-helmet";

class Registration extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            regions: [],
            formErrors: {
                nick: "",
                email: "",
                newMail: "",
                password: "",
                confirm_password: ""
            },
            activation: false,
            email: '',
            activationType: '',
            newMail: '',
            phone: '',
            message: '',
        };
    }


    onFormSubmit = event => {
        event.preventDefault();
        const data = getFormData(event.target);
        const formErrors = this.validateForm(data);
        if (!isEmpty(formErrors)) {
            this.setState({formErrors});
        } else {
            registerUser(data)
                .then(() => {
                    this.setState({activation: true, ...data})
                })
                .catch((errors) => {
                    this.setState({formErrors: errors.messages})
                });
        }
    };

    onSubmitFormActivateByCode = event => {
        event.preventDefault();
        const {setCurrentUser} = this.props;
        const {code} = this.state;
        activateUserByCode({code})
            .then((response) => {
                this.setState({
                    done: true,
                    message: response.message,
                });
                setCurrentUser(response.user);
            })
            .catch((error) => {
                this.setState({
                    pending: false,
                    error: error
                });
        });
    };

    validateForm = data => {
        const formErrors = {};

        if (data.nick && !data.nick.length) {
            formErrors.nick = t('Nick is required')
        }
        if (data.email && !/[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}/.test(data.email)) {
            formErrors.email = t('Invalid email')
        }
        if (data.email && !data.email.length) {
            formErrors.email = t('Email is required')
        }
        if (data.newMail && !/[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}/.test(data.newMail)) {
            formErrors.newMail = t('Invalid email')
        }
        if (data.newMail && !data.newMail.length) {
            formErrors.newMail = t('Email is required')
        }
        if (data.password && !data.password.length) {
            formErrors.password = t('Password is required')
        }
        if (data.password && (data.password !== data.confirm_password)) {
            formErrors.confirm_password = t("Password and confirmation doesn't match")
        }

        return formErrors;
    };

    changePhone = phone => {
        this.setState({phone, formErrors: {phone: ''}});
    };

    changeMail = event => {
        event.preventDefault();
        const newMail = event.target.value;
        this.setState({newMail, formErrors: {newMail: ''}})
    };

    changeCode = event => {
        event.preventDefault();
        const code = event.target.value;
        this.setState({code})
    };

    onSubmitFormPhone = e => {
        e.preventDefault();
        requestActivationSms({phone: this.state.phone}).then(() => {
            this.setState({
                activationType: "",
            });
        }).catch((error) => {
            this.setState({
                formErrors: {phone: error.message}
            });
        });
    };

    onSubmitFormMail = event => {
        event.preventDefault();
        const {newMail} = this.state;
        const formErrors = this.validateForm({newMail});

        if (!isEmpty(formErrors)) {
            this.setState({formErrors});
        } else {
            updateActivationEmail({email: newMail}).then(() => {
                this.setState({
                    activationType: "",
                    email: newMail,
                });
            }).catch((error) => {
                this.setState({
                    formErrors: {newMail: error.message}
                });
            });
        }
    };

    setActivationType = activationType => event => {
        event.preventDefault();
        return (
            this.setState({activationType})
        )
    };
    
    onCountrySelectChange = event => {
        let country = event.target.value;
        this.getRegions(country);
    };
    
    getRegions = country => {
        let that = this;
        getRegions(country).then(function(response) {
            that.setState({regions: response.data});
        })
    };
    
    componentDidMount() {
        this.getRegions("FR");
    }
    
    componentDidUpdate(prevProps, prevState, snapshot) {
        if (!this.state.activation && this.props.currentUser.active === 0) {
            this.setState({activation: true})
        }
        if (!this.state.email) {
            this.setState({email: this.props.currentUser.email});
        }
    }
    
    render() {
        const localeCode = getLocale();
        const {regions, formErrors, activation, email, activationType, done, message} = this.state;
        const phoneActivation = activationType === 'phone';
        const emailActivation = activationType === 'email';

        return(
            <div id='wrapper'>
                <Helmet>
                    <title>{dt('meta', 'Registration at BobTV')}</title>
                    <meta
                        name="description"
                        content={dt('meta',
                            'bobTV Webcam Chat free registration. Video Chat exhibitions and meetings between adults.')}
                    />
                </Helmet>
                <header className='registration'>
                    {!activation ?
                        <div className='content'>
                            <h1>{t('Registration')}</h1>
                            <div className='text-registration'>
                                <form onSubmit={this.onFormSubmit}>
                                    <div className='space-between'>
                                        <FormField error={formErrors.nick}>
                                            <label>{t('Nick:')}</label>
                                            <input type='text' name='nick'/>
                                        </FormField>
                                        <FormField error={formErrors.email}>
                                            <label>{t('Email:')}</label>
                                            <input type='text' name='email'/>
                                        </FormField>
                                    </div>
                                    <div className='space-between'>
                                        <FormField error={formErrors.password}>
                                            <label>{t('Password:')}</label>
                                            <input type='password' name='password'/>
                                        </FormField>
                                        <FormField error={formErrors.confirm_password}>
                                            <label>{t('Confirm password:')}</label>
                                            <input type='password' name='confirm_password'/>
                                        </FormField>
                                    </div>
                                    <div className='space-between info-gender'>
                                        <div>
                                            <label>{t('Age:')}</label>
                                            <div className='flex space-between'>
                                                <div className='age'>
                                                    <input type='number' min='18' max='99' name='age'/> <span style={{display: 'inline-block', verticalAlign: 'middle'}}>{t('years')}</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div>
                                            <label>{t('Gender:')}</label>
                                            <GenderSelect name='gender'/>
                                        </div>
                                    </div>
                                    <div className='space-between'>
                                        <div>
                                            <label>{t('Country:')}</label>
                                            <select name='country' defaultValue='FR' onChange={this.onCountrySelectChange}>
                                                <option value="">{t('Select one...')}</option>
                                                {countries.map((country) => <option value={country.code} key={country.code}>{country[localeCode]}</option>)}
                                            </select>
                                        </div>
                                        <div>
                                            <label>{t('Region:')}</label>
                                            <select name='region' id="">
                                                <option value="">{t('Any')}</option>
                                                {regions.map((region) => <option value={region.code} key={region.code}>{region[localeCode]}</option>)}
                                            </select>
                                        </div>
                                    </div>
                                    <div style={{marginTop: '35px'}}>
                                        <div>
                                            <button type='submit' className='btn-submit'>{t('Send')}</button>
                                        </div>
                                        <div>
                                            <Link to='/connexion' className='member'>{t('I\'m already registered')}</Link>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                        :
                        <div className='content'>
                            <h1>{t('Activation')}</h1>
                            <div className='text-confirm-registration'>
                                <p
                                    dangerouslySetInnerHTML={{__html:t("Please enter the activation code we sent to your email " +
                                            "<span class=\"underline\">%1</span> or clicking the activation link from email message.", escape(email))}}
                                />
                                <p>{t('If you do not receive this email immediately, check your "spam" folder and mark this as "non-spam".')}</p>
                                <p
                                    dangerouslySetInnerHTML={{
                                        __html:
                                            t(
                                                "If you can not find this email, activate your account par SMS or %1 so that I manually activate your account.",
                                                <Link href={paths.contact.path} target="_blank">{t('contact me')}</Link>
                                            )
                                    }}
                                />
                            </div>
                            <form className="activation-form">
                                <div className="buttons">
                                    <button className={emailActivation ? 'active' : null} onClick={this.setActivationType('email')}>{t('Change email')}</button>
                                    <button className={phoneActivation ? 'active' : null} onClick={this.setActivationType('phone')}>{t('Send to phone')}</button>
                                </div>
                                {emailActivation &&
                                    <div className={`code ${formErrors.newMail ? 'error' : ''}`}>
                                        <FormField>
                                            <label>{t('New email address:')}</label>
                                            <input type='text' name='newMail' onChange={this.changeMail}/>
                                            {formErrors.newMail && <p>{formErrors.newMail}</p>}
                                        </FormField>
                                        <button className="active" onClick={this.onSubmitFormMail}>{t('Send')}</button>
                                    </div>
                                }
                                {phoneActivation &&
                                    <div className={`code ${formErrors.phone ? 'error' : ''}`}>
                                        <div>
                                            <label>{t('Activation code:')}</label>
                                            <ReactPhoneInput
                                                name="phone"
                                                defaultCountry="fr"
                                                flagsImagePath={flags}
                                                onChange={e => this.changePhone(e)}
                                            />
                                            {formErrors.phone && <p>{formErrors.phone}</p>}
                                        </div>
                                        <button className="active" onClick={this.onSubmitFormPhone}>{t('Send')}</button>
                                    </div>
                                }
                                {!emailActivation && !phoneActivation &&
                                    <div className="code">
                                        <FormField>
                                            <label>{t('Activation code:')}</label>
                                            <input type='text' name='code' placeholder="XXXX" onChange={e => this.changeCode(e)}/>
                                        </FormField>
                                        <button className="active" onClick={this.onSubmitFormActivateByCode}>{t('Send')}</button>
                                    </div>
                                }
                            </form>
                        </div>
                    }
                    {done &&
                        <div className="content">
                            <div className="text-confirm-registration">
                                <p
                                    dangerouslySetInnerHTML={{
                                        __html: message
                                    }}
                                />
                                <p>
                                    <Link to="/">{t('You can start using BobTV')}</Link>
                                </p>
                            </div>
                        </div>
                    }
                </header>
                <Footer />
            </div>
        )
    }
}

const mapStateToProps = state => ({
    currentUser: state.currentUser
});

const mapDispatchToProps = {
    setCurrentUser
};

export default connect(mapStateToProps, mapDispatchToProps)(Registration);



// WEBPACK FOOTER //
// ./src/containers/Registration.js